export default class PrilohaService{

  constructor($q){
    this.$q = $q;
  }

  serializePrilohy(prilohy){
    return this.$q.all((prilohy||[]).map(priloha => this._serializePriloha(priloha)))
  }

  _serializePriloha(priloha){
    return this.$q((resolve, reject)=>{
      if(priloha && priloha.file instanceof File && !priloha.deleted){
        var reader = new FileReader();
        reader.onload = function(){
          resolve({
            id: priloha.id,
            file: {
              name: priloha.file.name,
              size: priloha.file.size,
              content: reader.result
            }
          })
        }
        reader.onerror = function(err){
          reject(err);
        }
        reader.readAsDataURL(priloha.file);
      }else{
        resolve(priloha);
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/services/PrilohaService.js